import { Environment } from '../index';
export { lifeCycleEventName } from './lifeCycleEventName';
export const DEVICE_ID_STORAGE_KEY = 'AIR_ANALYTICS_DEVICE_ID';
export { UNKNOWN_VALUE, DEFAULT_CONFIG, DEFAULT_COMMON_DATA } from './config';
export { SeverityType, PlatformType, Environment, NetworkType, AutoDetectedErrorType, StaticFileType, PerformanceType, } from './common';
export const loggingServiceCorsUrl = (env) => {
    if (env == Environment.production) {
        return 'https://api.airwallex.com/papluginlogs/cors-logs';
    }
    if (env == Environment.demo) {
        return 'https://api-demo.airwallex.com/papluginlogs/cors-logs';
    }
    return 'https://api-staging.airwallex.com/papluginlogs/cors-logs';
};
export const loggingServicePublishUrl = (env) => {
    if (env == Environment.production) {
        return 'https://api.airwallex.com/papluginlogs/logs';
    }
    if (env == Environment.demo) {
        return 'https://api-demo.airwallex.com/papluginlogs/logs';
    }
    return 'https://api-staging.airwallex.com/papluginlogs/logs';
};
